import { normalizeSubscriber } from "./normalizeSubscriber.js";
/**
 * Combines multiple subscribers into a single observer.
 *
 * @public
 */
export function combineSubscribers(...subscribers) {
    return {
        next(value) {
            for (const subscriber of subscribers) {
                normalizeSubscriber(subscriber)?.next(value);
            }
        },
        error(error) {
            for (const subscriber of subscribers) {
                normalizeSubscriber(subscriber)?.error?.(error);
            }
        },
        complete() {
            for (const subscriber of subscribers) {
                normalizeSubscriber(subscriber)?.complete?.();
            }
        },
    };
}
